import {
  GridColDef,
  GridCsvGetRowsToExportParams,
  GridPrintExportOptions,
  gridFilteredSortedRowIdsSelector,
  gridSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector,
  useGridApiContext,
} from "@mui/x-data-grid-premium";
import React, { useState } from "react";
import { useDispatch, useSelector } from "../../store";
import { Button, ButtonProps } from "@mui/material";
import { Email, GetApp } from "@mui/icons-material";
import { GridApiCommunity } from "@mui/x-data-grid/internals";
import { pdf } from "@react-pdf/renderer";
import ReportExportPdf from "../views/Reports/ReportExportPdf";
import { saveAs } from "file-saver";
import ExcelReport from "../../types/excelReport";
import ExcelRows from "../../types/excelRows";
import { excelReport } from "../../slices/report";
import SearchResults from "../../types/searchResults";

interface Props {
  totalRows: number;
  handlePreExport?: () => Promise<void>;
  //replace with function to get all rows when serverside had been added, if ever
  displayRows?: (array: SearchResults) => Record<string, string | undefined>[];
  loading?: boolean;
}

const TableToolbar: React.FC<Props> = (props) => {
  const { totalRows, handlePreExport, displayRows, loading } = props;
  const apiRef = useGridApiContext();
  const dispatch = useDispatch();
  const [emailModal, setEmailModal] = useState<{
    visible: boolean;
    type?: "pdf" | "excel";
  }>({ visible: false });
  const { status } = useSelector((store) => store.report);

  const getAllRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridSortedRowIdsSelector(apiRef);

  // const getExcelData = (apiRef: React.MutableRefObject<GridApiCommunity>) => {
  //   const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  //   const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
  //   const columns = visibleColumnFields.filter((c) => c !== "actions");

  //   const data = filteredSortedRowIds.map((id) => {
  //     let row: any = {};
  //     columns.forEach((field) => {
  //       row[field] = apiRef.current.getCellParams(id, field).value;
  //     });
  //     return row;
  //   });
  //   return data;
  // };

  const handleExportAllPrint = (options: GridPrintExportOptions) => {
    handlePreExport?.().then(() => {
      apiRef.current.setPageSize(totalRows!);
      apiRef.current.exportDataAsPrint({
        ...options,
        pageStyle: "landscape",
      });
    });
  };

  const handleEmailPdf = (emails: string[]) => {
    //   handlePreExport?.().then(async () => {
    //     apiRef.current.setPageSize(totalRows!);
    //     const blob = await pdf(
    //       <ReportPdfView text={apiRef.current.getDataAsCsv({})} />
    //     ).toBlob();
    //     dispatch(emailJobTimeReport({ blob: blob, type: "pdf", email: emails }));
    //   });
  };

  const handleEmailExcel = (emails: string[]) => {
    //   handlePreExport?.().then(async () => {
    //     apiRef.current.setPageSize(totalRows!);
    //     const data = getExcelData(apiRef);
    //     const worksheet = XLSX.utils.json_to_sheet(data);
    //     XLSX.utils.sheet_add_aoa(
    //       worksheet,
    //       [
    //         [
    //           ...columns
    //             .filter((c) => c.headerName !== "Actions")
    //             .map((c) => {
    //               return c.headerName;
    //             }),
    //         ],
    //       ],
    //       { origin: "A1" }
    //     );
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Hours Report");
    //     const file = await XLSX.write(workbook, {
    //       type: "array",
    //     });
    //     const blob = await new Blob([file], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
    //     });
    //     dispatch(
    //       emailJobTimeReport({ blob: blob, type: "excel", email: emails })
    //     );
    //   });
  };
  const printPdf = async () => {
    handlePreExport?.().then(async (result: any) => {
      console.log(result);
      const visibleRows = apiRef.current.getVisibleColumns();
      //if server side paging, run pre-export and set result.payload.results as rows
      var results = result.payload;
      const newRows = displayRows?.(results)!;
      const blob = await pdf(
        <ReportExportPdf rows={newRows} columns={visibleRows} />
      ).toBlob();
      saveAs(blob, `DetectorReport.pdf`);
    });
  };

  const printExcel = () => {
    handlePreExport?.().then(async (result: any) => {
      const report: ExcelReport = { columns: [], rows: [] };
      const visibleCols = apiRef.current.getVisibleColumns();
      const results = result.payload;
      const newRows = displayRows?.(results)!;
      visibleCols.forEach((col) => {
        report.columns.push({ field: col.field, label: col.headerName! });
      });
      newRows.forEach((row: any) => {
        const rowArray: ExcelRows = { rowContent: [] };
        for (let key in row) {
          rowArray.rowContent.push({ field: key, label: row[key] });
        }
        report.rows.push(rowArray);
      });
      dispatch(excelReport(report));
    });
  };

  const exportButtonBaseProps: ButtonProps = {
    color: "primary",
    size: "small",
    startIcon: <GetApp />,
    disabled: !!loading,
  };

  const emailButtonBaseProps: ButtonProps = {
    ...exportButtonBaseProps,
    startIcon: <Email />,
  };

  return (
    <>
      <Button
        {...exportButtonBaseProps}
        onClick={printExcel}
        disabled={status === "loading"}
      >
        Export All as Excel
      </Button>
      {/* <Button
        {...emailButtonBaseProps}
        onClick={() => {
          setEmailModal({ visible: true, type: "excel" });
        }}
      >
        Email All as Excel
      </Button> */}
      {/* <Button
        {...exportButtonBaseProps}
        onClick={() => {
          handleExportAllPrint({ getRowsToExport: getAllRows });
        }}
      >
        Print All
      </Button> */}
      {/* <Button {...exportButtonBaseProps} onClick={printPdf}>
        Export All as PDF
      </Button> */}
    </>
  );
};

export default TableToolbar;
